import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({ selector: '[accordion]' })
export class AccordionDirective {
  public constructor(private el: ElementRef<HTMLElement>) {}

  @HostListener('click')
  public onClick(): void {
    this.el.nativeElement.classList.toggle('is-open');

    const content: HTMLElement = this.el.nativeElement.nextElementSibling as HTMLElement;
    if (content.style.maxHeight) {
      // accordion is currently open, so close it
      content.style.maxHeight = '';
    } else {
      // accordion is currently closed, so open it
      if (content && content.scrollHeight) {
        content.style.maxHeight = content.scrollHeight.toString() + 'px';
      }
    }
  }
}
